module.exports = __webpack_public_path__ + "static/media/puzzle_4-2.66996505.jpg";